<script setup>
import {
  StatusEnum,
  WorkAreaEnum,
  StatusEsgCommentEnum,
  TypeFileEnum,
} from "@/utilities/enum";
import moment from "moment-timezone";
moment.locale("id");
</script>

<template>
  <DefaultLayout class="!bg-slate-50">
    <v-row class="mt-2 font-inter" :class="[commentVisible ? 'mx-2' : 'mx-5']">
      <v-col
        class="transition-all duration-300 ease-in-out"
        :class="[commentVisible ? 'pr-72' : '']"
      >
        <div class="flex justify-between items-center">
          <div>
            <div class="flex justify-start items-center gap-1">
              <h5
                class="text-red-600 font-semibold text-nowrap cursor-pointer hover:text-red-400"
                :class="{
                  'text-xs': !commentVisible,
                  'text-[10px]': commentVisible,
                }"
                @click="$router.push({ path: '/esg-report', query: $route.query })"
              >
                ESG Report
              </h5>
              <i class="mdi mdi-chevron-right text-xl"></i>
              <span
                :class="{
                  'text-xs': !commentVisible,
                  'text-[10px]': commentVisible,
                  'text-red-600 cursor-pointer font-semibold hover:text-red-400':
                    url_navlink,
                  'text-gray-800 font-medium': !url_navlink,
                }"
                @click="url_navlink ? $router.push(url_navlink) : ''"
              >
                {{ month.name + " " + year }}
              </span>
              <i class="mdi mdi-chevron-right text-xl"></i>
              <span
                class="text-gray-800 font-medium"
                :class="{
                  'text-xs': !commentVisible,
                  'text-[10px]': commentVisible,
                }"
              >
                Area {{ workArea }}
              </span>
            </div>
            <h2 class="font-bold text-xl text-[#232323] font-inter">
              <i
                class="mdi mdi-arrow-collapse-left font-bold cursor-pointer hover:text-gray-600"
                @click="
                  $route.params.id_contractor
                    ? $router.push(url_navlink)
                    : $router.push({ path: '/esg-report', query: $route.query })
                "
              ></i>
              {{
                !commentVisible
                  ? ($route.params.main_contractor_name ?? kontraktorName) +
                    " - " +
                    month.name +
                    " " +
                    year
                  : month.name + " " + year
              }}
            </h2>
          </div>
          <div class="flex justify-end items-center gap-3" v-if="Number(year) >= 2025">
            <div
              :class="{
                'text-xs': !commentVisible,
                'text-[10px]': commentVisible,
              }"
            >
              <h6 class="font-normal text-stone-500">
                {{
                  status === StatusEnum.COMPLETED
                    ? "Approved On:"
                    : "Last Saved:"
                }}
              </h6>
              <h5 class="font-normal text-stone-800">
                {{
                  existing.lastSaved
                    ? moment(existing.lastSaved)
                        .tz("Asia/Singapore")
                        .format(
                          `DD MMM YYYY ${
                            status === StatusEnum.COMPLETED
                              ? ""
                              : "[-] HH.mm [(GMT +8)]"
                          }`
                        )
                    : "-"
                }}
                <template v-if="existing.approved_by">
                  By
                  <span class="font-semibold">{{ existing.approved_by }}</span>
                </template>
              </h5>
            </div>
            <div
              class="min-w-[1px] bg-[#CCCCCC] h-9"
              v-if="
                ((status === StatusEnum.REVISION ||
                  status === StatusEnum.DRAFT ||
                  (status === StatusEnum.COMPLETED && isAdmin) ||
                  !status) &&
                  !userData.isPjo) ||
                ((status == StatusEnum.REVISION ||
                  status === StatusEnum.WAITING_APPROVAL) &&
                  userData.isPjo)
              "
            ></div>
            <template
              v-if="
                (status === StatusEnum.DRAFT ||
                  status === StatusEnum.REVISION ||
                  !status ||
                  (status === StatusEnum.COMPLETED && isAdmin)) &&
                !userData.isPjo
              "
            >
              <div
                class="relative"
                v-if="!isAdmin && !$route.params.id_contractor"
              >
                <img
                  src="../../assets/icon/chat.png"
                  alt="icon chat"
                  class="w-7 h-auto cursor-pointer"
                  @click="openComment()"
                  v-if="comments.length"
                />
                <div
                  class="py-1 px-[7px] rounded-full bg-red-700 -top-2 left-4 z-10 absolute"
                  v-if="comments.length"
                >
                  <h6 class="text-white text-[10px]">
                    {{
                      comments.filter(
                        (item) =>
                          item?.status === StatusEsgCommentEnum.NEED_REVISION
                      ).length
                    }}
                  </h6>
                </div>
              </div>
              <v-btn
                variant="outlined"
                class="capitalize text-xs w-32 border-gray-400 bg-white"
                @click="submitData(false, true)"
                v-if="!isAdmin"
              >
                <span class="text-gray-500"> Simpan </span>
              </v-btn>
              <v-btn
                variant="text"
                v-if="
                  !$route.params.id_contractor ||
                  ($route.params.id_contractor && isAdmin)
                "
                class="capitalize text-xs w-32 font-medium"
                @click="
                  isSubmit && isAdmin
                    ? submitData(true, true)
                    : isSubmit && !isAdmin
                    ? (dialogSubmission = true)
                    : ''
                "
                id="btn-submit"
                :class="[
                  isSubmit
                    ? 'bg-red-600 text-white'
                    : 'bg-gray-200 text-stone-400',
                ]"
              >
                Submit
                <img
                  :src="
                    require(`../../assets/icon/${
                      isSubmit ? 'send.png' : 'send-off.png'
                    }`)
                  "
                  alt="Submit Icon"
                  class="ml-2 h-4 w-auto"
                />
              </v-btn>
            </template>
            <template
              v-if="
                (status === StatusEnum.WAITING_APPROVAL ||
                  status === StatusEnum.REVISION) &&
                userData.isPjo &&
                !$route.params?.id_contractor
              "
            >
              <img
                src="../../assets/icon/chat.png"
                alt="icon chat"
                class="w-7 h-auto cursor-pointer relative"
                @click="openComment()"
              />
              <v-menu
                :close-on-content-click="false"
                @click:outside="menuVisible = false"
                v-if="status === StatusEnum.WAITING_APPROVAL"
              >
                <template v-slot:activator="{ props }">
                  <div
                    v-bind="props"
                    class="flex gap-3 items-center cursor-pointer rounded font-medium py-1 px-7 text-white"
                    :class="[
                      menuVisible ? 'bg-slate-950' : 'bg-orange-400',
                      commentVisible ? 'text-xs' : 'text-sm',
                    ]"
                    @click="menuVisible = !menuVisible"
                  >
                    <span>
                      {{ userData.isPjo ? "Need Approval" : "Revision" }}
                    </span>
                    <i
                      class="mdi mdi-menu-up text-2xl duration-300 ease-in"
                      :class="{ 'rotate-180': !menuVisible }"
                    ></i>
                  </div>
                </template>
                <v-list class="py-0">
                  <v-list-item
                    class="hover:bg-orange-50 py-2 px-3 text-orange-400 hover:text-orange-500 font-medium text-sm cursor-pointer"
                    @click="
                      comments.filter(
                        (item) => item.status === StatusEsgCommentEnum.DRAFT
                      ).length
                        ? actionValidate(StatusEnum.REVISION)
                        : openComment()
                    "
                  >
                    <div
                      class="bg-orange-100 hover:bg-orange-200 rounded py-2 px-3"
                    >
                      Revisi
                    </div>
                  </v-list-item>
                  <v-list-item
                    class="hover:bg-green-50 py-2 px-3 text-green-400 hover:text-green-500 font-medium text-sm cursor-pointer"
                    @click="
                      comments.every(
                        (item) => item.status === StatusEsgCommentEnum.SOLVED
                      )
                        ? (dialogApprove = true)
                        : openComment()
                    "
                  >
                    <div
                      class="bg-green-100 hover:bg-green-200 rounded py-2 px-3"
                    >
                      Approve
                    </div>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </div>
        </div>
        <template v-if="$route.params?.id_contractor">
          <div
            class="bg-white rounded-md shadow-md my-3 relative"
            :class="[commentVisible ? 'p-2' : 'p-3']"
          >
            <p class="text-xs whitespace-pre-line text-gray-600">
              Sub Kontraktor
            </p>
            <h5 class="text-sm font-medium text-gray-900 mb-1">
              {{ kontraktorName }}
            </h5>
          </div>
        </template>
        <template v-if="status !== StatusEnum.COMPLETED && existing.note">
          <div
            class="bg-white rounded-md shadow-md my-3"
            :class="[commentVisible ? 'p-2' : 'p-3']"
          >
            <h5 class="text-sm font-medium text-gray-900 mb-1">
              Catatan Admin
            </h5>
            <p class="text-xs whitespace-pre-line text-gray-600">
              {{ existing.note }}
            </p>
          </div>
        </template>
        <div
          class="my-3 bg-white shadow-md rounded-md"
          v-if="displayData && workArea !== WorkAreaEnum.OTHERS"
        >
          <div
            class="w-full flex items-center"
            :class="[commentVisible ? 'p-2 gap-2' : 'p-3 gap-4']"
          >
            <div class="w-[330px] gap-2 flex items-center h-full relative">
              <img
                src="../../assets/icon/mining-production.png"
                alt="icon-mining"
                loading="lazy"
                class="w-7"
              />
              <h5 class="text-base font-medium text-gray-900">
                {{
                  workArea === WorkAreaEnum.MINING
                    ? "Mining Production"
                    : "Mitra " + capitalized(workArea)
                }}
              </h5>
              <div
                class="w-[2px] h-full bg-gray-400 absolute duration-300 ease-in right-2 rounded-md"
              ></div>
            </div>
            <v-form ref="formData" class="col-span-9 w-full">
              <div
                class="grid w-full"
                :class="[
                  workArea === WorkAreaEnum.MINING
                    ? 'grid-cols-2 gap-3'
                    : 'grid-cols-1',
                ]"
              >
                <div v-if="workArea === WorkAreaEnum.MINING">
                  <label for="" class="font-normal text-gray-800 text-sm">
                    OB Production (BCM)
                  </label>
                  <v-text-field
                    variant="outlined"
                    color="#475569"
                    density="compact"
                    placeholder="ex 100"
                    v-model="production.ob_production"
                    @input="handleInput($event, 'ob_production')"
                    :rules="formValidasiFuel.ob_production"
                    id="ob_production"
                    autocomplete="off"
                    hide-details="auto"
                    v-if="
                      (!status ||
                        status === StatusEnum.DRAFT ||
                        status === StatusEnum.REVISION ||
                        (status === StatusEnum.COMPLETED && isAdmin)) &&
                      !userData.isPjo
                    "
                  ></v-text-field>
                  <h6 v-else class="font-medium text-sm">
                    {{ production.ob_production }}
                  </h6>
                </div>
                <div>
                  <label for="" class="font-normal text-gray-800 text-sm">
                    Coal Production (Ton)
                  </label>
                  <v-text-field
                    variant="outlined"
                    color="#475569"
                    density="compact"
                    placeholder="ex 100"
                    v-model="production.coal_production"
                    @input="handleInput($event, 'coal_production')"
                    :rules="formValidasiFuel.coal_production"
                    id="coal_production"
                    autocomplete="off"
                    hide-details="auto"
                    v-if="
                      (!status ||
                        status === StatusEnum.DRAFT ||
                        status === StatusEnum.REVISION ||
                        (status === StatusEnum.COMPLETED && isAdmin)) &&
                      !userData.isPjo
                    "
                  ></v-text-field>
                  <h6 v-else class="font-medium text-sm">
                    {{ production.coal_production }}
                  </h6>
                </div>
              </div>
            </v-form>
          </div>
        </div>

        <div
          class="flex w-full mb-10 mt-5"
          v-if="displayData"
          :class="[commentVisible ? 'gap-2' : 'gap-4']"
        >
          <div
            class="bg-white shadow-md rounded-md h-fit gap-3 flex flex-col transition-all duration-300 ease-in"
            :class="[commentVisible ? 'w-16 p-2' : 'w-64 p-3']"
          >
            <div
              v-for="type in typeConsume.filter((item) => item.show)"
              :key="type.id"
              class="flex flex-col gap-3"
            >
              <h3 class="font-semibold text-base text-gray-800 text-nowrap">
                {{ commentVisible ? type.titleMinimize : type.title }}
              </h3>
              <div
                class="gap-3 flex flex-col"
                :class="{
                  'mb-1': type.id === 1,
                }"
              >
                <CardTypeConsumeComponent
                  v-for="consume in type.type"
                  :key="consume.id"
                  :data="consume"
                  :minimize="commentVisible"
                  :active="typeConsumeActive === consume.id"
                  @change-type-consume="changeTypeActive"
                />
              </div>
            </div>
            <hr class="border-t-2 border-dashed border-gray-500" />
            <v-tooltip
              text="View All Summaries"
              location="top"
              :disabled="!commentVisible"
            >
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  :class="[
                    commentVisible
                      ? 'w-11 p-2 justify-center'
                      : 'w-56 px-3 py-2 justify-start gap-2',
                    isValid
                      ? 'cursor-pointer hover:bg-slate-100 bg-white '
                      : 'cursor-not-allowed opacity-80',
                  ]"
                  class="flex items-center border-[2px] rounded-md transition-all duration-200 ease-in"
                  @click="isValid ? calculateSummary() : ''"
                >
                  <img
                    src="../../assets/icon/note.png"
                    alt="icon"
                    loading="lazy"
                    class="w-5 h-auto"
                  />
                  <span
                    class="text-gray-600 text-sm font-medium"
                    v-if="!commentVisible"
                  >
                    View All Summaries
                  </span>
                </div>
              </template>
            </v-tooltip>
            <v-tooltip
              text="Download All Summaries"
              location="top"
              :disabled="!commentVisible"
            >
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  :class="[
                    commentVisible
                      ? 'w-11 p-2 justify-center'
                      : 'w-56 px-3 py-2 justify-start gap-2',
                    idEsg && status !== StatusEnum.DRAFT
                      ? 'cursor-pointer hover:bg-slate-100 bg-white '
                      : 'cursor-not-allowed opacity-80',
                  ]"
                  class="flex items-center border-[2px] rounded-md bg-white cursor-pointer hover:bg-slate-100 transition-all duration-200 ease-in"
                  @click="
                    idEsg && status !== StatusEnum.DRAFT ? downloadExcel() : ''
                  "
                >
                  <img
                    src="../../assets/icon/download.png"
                    alt="icon"
                    loading="lazy"
                    class="w-5 h-auto"
                  />
                  <span
                    class="text-gray-600 text-sm font-medium"
                    v-if="!commentVisible"
                  >
                    Download All Summaries
                  </span>
                </div>
              </template>
            </v-tooltip>
            <v-tooltip
              text="View File Keabsahan"
              location="top"
              :disabled="!commentVisible"
            >
              <template v-slot:activator="{ props }">
                <div
                  v-bind="props"
                  :class="[
                    commentVisible
                      ? 'w-11 p-2 justify-center'
                      : 'w-56 px-3 py-2 justify-start gap-2',
                    file_validity
                      ? 'cursor-pointer hover:bg-slate-100 bg-white '
                      : 'cursor-not-allowed opacity-80',
                  ]"
                  class="flex items-center border-[2px] rounded-md bg-white cursor-pointer hover:bg-slate-100 transition-all duration-200 ease-in"
                  @click="file_validity ? download(file_validity) : ''"
                >
                  <img
                    src="../../assets/icon/download.png"
                    alt="icon"
                    loading="lazy"
                    class="w-5 h-auto"
                  />
                  <span
                    class="text-gray-600 text-sm font-medium text-nowrap"
                    v-if="!commentVisible"
                  >
                    View File Keabsahan
                  </span>
                </div>
              </template>
            </v-tooltip>
            <template
              v-if="
                !userData.isPjo &&
                (status === StatusEnum.REVISION ||
                  status === StatusEnum.DRAFT ||
                  !status) &&
                !$route.params.id_contractor
              "
            >
              <hr class="border-t-2 border-dashed border-gray-500" />
              <v-tooltip
                text="Generate File Keabsahan"
                location="top"
                :disabled="!commentVisible"
              >
                <template v-slot:activator="{ props }">
                  <div
                    v-bind="props"
                    :class="[
                      commentVisible
                        ? 'w-11 p-2 justify-center'
                        : 'w-56 px-3 py-2 justify-start gap-2',
                    ]"
                    class="flex items-center border-[2px] rounded-md bg-white cursor-pointer hover:bg-slate-100 transition-all duration-200 ease-in"
                    @click="openDialogGenerateFileValidity()"
                  >
                    <img
                      src="../../assets/icon/content-setting.png"
                      alt="icon"
                      loading="lazy"
                      class="w-5 h-auto"
                    />
                    <span
                      class="text-gray-600 text-sm font-medium text-nowrap"
                      v-if="!commentVisible"
                    >
                      Generate File Keabsahan
                    </span>
                  </div>
                </template>
              </v-tooltip>
            </template>
          </div>
          <div class="w-full transition-all duration-300 ease-in">
            <v-form
              ref="formDetail"
              class="bg-white shadow-md p-3 rounded-md h-fit gap-3 flex flex-col"
            >
              <ContentFuelComponent
                v-if="typeConsumeActive === 1"
                v-model:dataTable="dataTableFuel"
                :existing="existing.fuel"
                :list-fuel="listFuel"
                :add-row="addRowFuel"
                :handle-input="handleInput"
                :get-fuel="getFuel"
                :remove-row="removeRowFuel"
                :formValidasi="formValidasiFuel"
                :work-area="workArea"
                :is-pjo="userData.isPjo"
                :status="status"
                :is-admin="isAdmin"
                @fetch-data="fetchDataFuel"
                @search-data="fuelSearch"
              />
              <ContentElektrificationComponent
                v-if="typeConsumeActive === 2"
                v-model:dataTable="dataTableElectric"
                :existing="existing.electric"
                :list-elektric="listElektric"
                :get-electric="getElectric"
                :formValidasi="formValidasiElectric"
                :handle-input="handleInput"
                :add-row="addRowElectric"
                :remove-row="removeRowElectric"
                :is-pjo="userData.isPjo"
                :status="status"
                :is-admin="isAdmin"
                @fetch-data="fetchDataElectric"
                @search-data="electricSearch"
              />
              <ContentRenewableEnergyComponent
                v-if="typeConsumeActive === 3"
                v-model:dataTable="dataTableRenewableEnergy"
                :existing="existing.renewableEnergy"
                :list-renewable-energy="listRenewableEnergy"
                :get-renewable-energy="getRenewableEnergy"
                :formValidasi="formValidasiRenewableEnergy"
                :handle-input="handleInput"
                :add-row="addRowRenewableEnergy"
                :remove-row="removeRowRenewableEnergy"
                :is-pjo="userData.isPjo"
                :status="status"
                :is-admin="isAdmin"
                @fetch-data="fetchDataRenewableEnergy"
                @search-data="renewableEnergySearch"
              />

              <ContentEquipmentComponent
                v-if="typeConsumeActive === 5"
                v-model:dataTable="dataTableEquipment"
                :existing="existing.equipment"
                :list-equipment="listEquipment"
                :formValidasi="formValidasiEquipment"
                :handle-input="handleInput"
                :get-equipment="getEquipment"
                :add-row="addRowEquipment"
                :remove-row="removeRowEquipment"
                :is-pjo="userData.isPjo"
                :is-admin="isAdmin"
                :status="status"
                :set-tab-active="changeTypeEquipment"
                @fetch-data="fetchDataEquipment"
                @search-data="equipmentSearch"
              />
            </v-form>
            <div
              class="mt-4 flex flex-wrap gap-2"
              v-if="!$route.params?.id_contractor"
            >
              <CardSubContractorComponent
                v-for="(data, index) in subContractor"
                :key="index"
                :data="data"
                :year="year"
                :month="month"
                :work-area="workArea"
                :is-pjo="userData.isPjo"
                :is-inputer="!userData.isPjo && !Array.isArray(userData?.role)"
                @click="saveData(data.id_contractor, data.id)"
              />
            </div>
          </div>
        </div>
        <div class="flex justify-center h-auto items-center w-full" v-else>
          <div class="flex flex-col justify-center">
            <img
              src="../../assets/icon/empty-data.png"
              alt="img empty"
              class="w-80 h-auto"
            />
            <template v-if="!userData.isPjo">
              <h5 class="text-base font-medium text-center -mt-8">
                Form tidak ditemukan
              </h5>
              <h6 class="text-sm font-normal text-center">
                Anda tidak dapat melakukan pengisian pada form ini!
              </h6>
            </template>
            <template v-else>
              <h5 class="text-base font-medium text-center -mt-8">
                Belum ada data disini
              </h5>
              <h6
                class="text-sm font-normal text-center"
                v-if="!$route.params.id_contractor"
              >
                Report ini masih dalam proses pengisian!
              </h6>
            </template>
          </div>
        </div>
      </v-col>
      <v-col
        v-show="commentVisible"
        class="fixed top-0 right-0 h-screen bg-white shadow-md p-2 transition-transform duration-700 ease-in flex flex-col"
        :class="[commentVisible ? 'w-72' : 'w-0 overflow-hidden']"
        style="z-index: 1005"
      >
        <div
          class="flex items-center justify-between bg-stone-50 rounded px-2 py-2 mt-20"
        >
          <h3 class="font-medium text-base text-slate-900">
            Comment({{ comments.length }})
          </h3>
          <img
            src="../../assets/icon/close-circle.png"
            alt="close"
            class="w-6 h-auto cursor-pointer"
            @click="closeComment"
          />
        </div>

        <div
          class="flex flex-1 flex-col gap-2 justify-between bg-stone-50 w-full rounded p-2 overflow-auto mt-2"
          style="box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05)"
        >
          <div
            class="overflow-auto h-full flex flex-col gap-2"
            :class="{ 'mb-40': status === StatusEnum.WAITING_APPROVAL }"
            ref="scrollContainer"
            v-if="comments.length || clickAddComment"
          >
            <CardCommentComponent
              v-for="(comment, i) in comments"
              :key="i"
              :comment="comment"
              :form-validasi="formValidasiComment"
              :is-pjo="userData.isPjo"
              :delete-comment="deleteComment"
              :solved-comment="solvedComment"
              :status="status"
              @edit-comment="editComment"
              @cancel-comment="cancelComment"
              @update-comment="updateComment"
            />
          </div>
          <div
            v-else
            class="h-full items-center flex justify-center flex-col relative"
          >
            <h6 class="font-normal text-sm text-stone-400">
              Mulai memberikan komentar
            </h6>
            <v-btn
              class="bg-slate-950 text-white capitalize px-6 text-sm font-medium mt-2"
              @click="clickAddComment = true"
            >
              Tambah Komentar
            </v-btn>

            <p class="text-center text-stone-400 text-xs absolute bottom-1">
              Komentar diberikan untuk mempermudah tim dalam memperbaiki
              kekurangan data
            </p>
          </div>

          <v-form
            ref="formComment"
            class="fixed bottom-4 right-4 w-64 min-w-60 bg-white shadow-md p-2 rounded z-10"
            v-if="
              (clickAddComment || comments.length) &&
              status === StatusEnum.WAITING_APPROVAL
            "
          >
            <v-textarea
              variant="outlined"
              density="compact"
              auto-grow
              rows="2"
              :rules="formValidasiComment.message"
              v-model="formComment"
              class="custom-textarea"
            ></v-textarea>
            <v-btn
              class="bg-slate-950 text-white capitalize w-full text-sm font-medium mt-2"
              @click="addComment"
            >
              Komentar
            </v-btn>
          </v-form>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <SummaryModal
    v-model="dialogSummary"
    :loading="loadingSummary"
    :form-data="formDataSummary"
    :with-sub="false"
    :tabs="tabs"
    :is-pjo="userData.isPjo"
    :is-contractor="!Array.isArray(userData?.role)"
    :get-summary="getSummary"
    @close-modal="closeModal"
  />
  <SubmissionModal
    v-model="dialogSubmission"
    :dialog="dialogSubmission"
    :file-validity="file_validity"
    @close-modal="closeModal"
    @submission-data="
      (file_submission) => {
        file_validity = file_submission;
        submitData(true, true);
      }
    "
  />
  <ApproveModal
    v-model="dialogApprove"
    :action-validate="actionValidate"
    @close-modal="closeModal"
  />
  <GenerateFileValidityModal
    v-model="dialogGenerateFileValidity"
    :dialog="dialogGenerateFileValidity"
    :contractor-name="userData.kontraktorName"
    :pjo="pjo"
    :id-contractor="parseInt(kontraktorID)"
    @close-modal="closeModal"
  />
  <div v-if="isLoading" class="loading-overlay" style="z-index: 2110">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import util from "@/assets/js/util";
import {
  API_BASE_URL,
  APP_BACKEND_ESG,
  CMS_NOTIFICATION_ESG,
} from "@/constants";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import axios from "axios";
import CardTypeConsumeComponent from "./components/CardTypeConsumeComponent.vue";
import { CreateDataTableObject } from "@/utilities/DataTableHelpers";
import {
  formatNumber,
  formatNumberOnly,
  FormCreateDataEsgFormElectric,
  FormCreateDataEsgFormEquipment,
  FormCreateDataEsgFormFuel,
  FormCreateDataEsgFormRenewableEnergy,
  FormValidasiDataComment,
  FormValidasiDataElectric,
  FormValidasiDataEquipment,
  FormValidasiDataFuel,
  FormValidasiDataRenewableEnergy,
  typeEquipmentEnum,
} from "./core/FormData";
import { cloneDeep, debounce } from "lodash";
import ContentFuelComponent from "./components/ContentFuelComponent.vue";
import ContentElektrificationComponent from "./components/ContentElektrificationComponent.vue";
import ContentRenewableEnergyComponent from "./components/ContentRenewableEnergyComponent.vue";
import ContentEquipmentComponent from "./components/ContentEquipmentComponent.vue";
import CardSubContractorComponent from "./components/CardSubContractorComponent.vue";
import GlobalDataMixin from "@/GlobalDataMixin";
import { ActionEnum, JenisNotifEsgEnum } from "@/utilities/enum";
import SummaryModal from "./components/SummaryModal.vue";
import CardCommentComponent from "./components/CardCommentComponent.vue";
import SubmissionModal from "./components/SubmissionModal.vue";
import { capitalized } from "@/utilities/helpers";
import { upload } from "@/utilities/FileManager";
import {
  download,
  downloadReportESG,
  getSIOByIDContractor,
} from "@/utilities/globalFunction";
import ApproveModal from "./components/ApproveModal.vue";
import GenerateFileValidityModal from "./components/GenerateFileValidityModal.vue";

const base_url = APP_BACKEND_ESG;
const base_url_cms = API_BASE_URL;
const url_send_notification = API_BASE_URL + CMS_NOTIFICATION_ESG;

export default {
  name: "EsgDetailPage",
  mixins: [GlobalDataMixin],
  components: {
    DefaultLayout,
    CardTypeConsumeComponent,
    CardCommentComponent,
    ContentFuelComponent,
    ContentElektrificationComponent,
    ContentRenewableEnergyComponent,
    ContentEquipmentComponent,
    CardSubContractorComponent,
    SummaryModal,
    SubmissionModal,
    ApproveModal,
    GenerateFileValidityModal,
  },
  data() {
    return {
      production: {
        ob_production: null,
        coal_production: null,
      },
      dataTableFuel: CreateDataTableObject([
        {
          title: "",
          align: "center",
          width: "2%",
          cellClass: "custom-cell-spacing",
        },
        {
          title: "Jenis Emisi",
          align: "center",
          width: "20%",
          cellClass: "custom-cell-spacing",
        },
        {
          title: "Jenis Bahan Bakar",
          align: "center",
          width: "20%",
          cellClass: "custom-cell-spacing",
        },
        {
          title: "Konsumsi Bahan Bakar (Liter)",
          align: "center",
          width: "20%",
          cellClass: "custom-cell-spacing",
        },
        {
          title: "Distance (KM)",
          align: "center",
          width: "20%",
          cellClass: "custom-cell-spacing",
        },
        {
          title: "",
          align: "center",
          width: "3%",
          cellClass: "custom-cell-spacing",
        },
      ]),
      dataTableElectric: CreateDataTableObject([
        { title: "", align: "center", width: "5%" },
        { title: "Jenis Elektrifikasi", align: "center", width: "45%" },
        { title: "Jumlah Unit", align: "center", width: "30%" },
        { title: "File", align: "center", width: "30%" },
        { title: "Total Elektrifikasi (MWh)", align: "center", width: "45%" },
        { title: "", align: "center", width: "5%" },
      ]),
      dataTableRenewableEnergy: CreateDataTableObject([
        { title: "", align: "center", width: "5%" },
        { title: "Tipe Renewable", align: "center", width: "45%" },
        { title: "Konsumsi Renewable (MWh)", align: "center", width: "45%" },
        { title: "", align: "center", width: "5%" },
      ]),
      dataTableEquipment: CreateDataTableObject([
        { title: "", align: "center", width: "5%" },
        { title: "Jumlah Unit", align: "center", width: "45%" },
        { title: "Jenis Peralatan", align: "center", width: "45%" },
        { title: "", align: "center", width: "5%" },
      ]),
      existing: {
        fuel: {
          page: 1,
          perPage: 10,
          totalItems: 0,
          items: [],
          loading: false,
        },
        electric: {
          page: 1,
          perPage: 10,
          totalItems: 0,
          items: [],
          loading: false,
        },
        renewableEnergy: {
          page: 1,
          perPage: 10,
          totalItems: 0,
          items: [],
          loading: false,
        },
        equipment: {
          page: 1,
          perPage: 10,
          totalItems: 0,
          items: [],
          loading: false,
        },
        lastSaved: null,
        approved_by: null,
        note: null,
      },
      year: null,
      month: {},
      typeConsume: [
        {
          id: 1,
          title: "Hauling",
          titleMinimize: "Hau...",
          show: false,
          type: [
            {
              id: 5,
              name: "Unit",
              countType: 0,
              typeFilled: 0,
              iconActive: "truck-active.png",
              iconInactive: "truck-orange.png",
            },
          ],
        },
        {
          id: 2,
          title: "Tipe Konsumsi",
          titleMinimize: "Tipe",
          show: true,
          type: [
            {
              id: 1,
              name: "Bahan Bakar",
              countType: 0,
              typeFilled: 0,
              iconActive: "fuel-active.png",
              iconInactive: "fuel-inactive.png",
            },
            {
              id: 2,
              name: "Elektrifikasi",
              countType: 0,
              typeFilled: 0,
              iconActive: "elektrifikasi-active.png",
              iconInactive: "elektrifikasi-inactive.png",
            },
            {
              id: 3,
              name: "Renewable Energy",
              countType: 0,
              typeFilled: 0,
              iconActive: "renewable-active.png",
              iconInactive: "renewable-inactive.png",
            },
          ],
        },
      ],
      formValidasiFuel: cloneDeep(FormValidasiDataFuel),
      formValidasiElectric: cloneDeep(FormValidasiDataElectric),
      formValidasiRenewableEnergy: cloneDeep(FormValidasiDataRenewableEnergy),
      formValidasiEquipment: cloneDeep(FormValidasiDataEquipment),
      formValidasiComment: cloneDeep(FormValidasiDataComment),
      typeConsumeActive: 1,
      listFuel: [],
      listEquipment: [],
      listElektric: [],
      listRenewableEnergy: [],
      dialogSummary: false,
      idEsg: null,
      loadingEquipment: [],
      loadingSummary: false,
      isValid: false,
      isSubmit: false,
      status: null,
      displayData: false,
      menuVisible: false,
      commentVisible: false,
      comments: [],
      clickAddComment: false,
      formComment: null,
      dialogSubmission: false,
      dialogApprove: false,
      dialogGenerateFileValidity: false,
      isAdmin: false,
      workArea: null,
      initials: null,
      kontraktorID: null,
      filled_by: null,
      kontraktorName: null,
      formDataSummary: {},
      bodyNotification: {
        id_contractor: null,
        area: null,
      },
      subContractor: [],
      url_navlink: null,
      isLoading: false,
      tabs: [],
      file_validity: null,
      pjo: {
        name: null,
        ttd: null,
      },
    };
  },
  mounted() {
    if (
      !this.$route.params.year ||
      !this.$route.params.id_month ||
      !this.$route.params.workArea
    ) {
      this.$router.push({ path: "/esg-report", query: this.$route.query });
    } else {
      this.isAdmin =
        this.userData.role.includes("ADMIN") ||
        this.userData.role.includes("ENVIRONMENT");
      this.loadPage();
    }
  },
  watch: {
    "dataTableFuel.items": {
      handler(newItems) {
        newItems.forEach((item) => {
          const index = item.existing_index;

          if (index !== undefined && this.existing.fuel.items[index]) {
            const newItem = { ...item };
            delete newItem.existing_index;
            this.existing.fuel.items.splice(index, 1, newItem);
          }
        });

        const keyMap = new Map();

        this.existing.fuel.items
          .filter((data) => {
            return data.type_equipment && !data.deleted && data.fuel;
          })
          .forEach((item, index) => {
            let key = `${item.type_equipment}_${item.fuel.id}`;

            if (!keyMap.has(key)) {
              keyMap.set(key, []);
            }
            keyMap.get(key).push(index);
          });

        this.existing.fuel.items
          .filter((data) => {
            return data.type_equipment && !data.deleted && data.fuel;
          })
          .forEach((item) => {
            let key = `${item.type_equipment}_${item.fuel.id}`;

            const duplicateIndexes = keyMap.get(key);
            item.duplicate = duplicateIndexes.length > 1;
          });

        this.calculateRowValid(1);
      },
      deep: true,
    },
    "dataTableElectric.items": {
      handler(newItems) {
        newItems.forEach((item) => {
          const index = item.existing_index;

          if (index !== undefined && this.existing.electric.items[index]) {
            const newItem = { ...item };
            delete newItem.existing_index;
            this.existing.electric.items.splice(index, 1, newItem);
          }
        });

        const keyMap = new Map();

        this.existing.electric.items
          .filter((data) => !data.deleted && data.electric)
          .forEach((item, index) => {
            const key = `${item.electric.id}`;
            if (!keyMap.has(key)) {
              keyMap.set(key, []);
            }
            keyMap.get(key).push(index);
          });

        this.existing.electric.items
          .filter((data) => !data.deleted && data.electric)
          .forEach((item) => {
            const key = `${item.electric.id}`;
            const duplicateIndexes = keyMap.get(key);
            item.duplicate = duplicateIndexes.length > 1;
          });

        this.calculateRowValid(2);
      },
      deep: true,
    },
    "dataTableRenewableEnergy.items": {
      handler(newItems) {
        newItems.forEach((item) => {
          const index = item.existing_index;

          if (
            index !== undefined &&
            this.existing.renewableEnergy.items[index]
          ) {
            const newItem = { ...item };
            delete newItem.existing_index;
            this.existing.renewableEnergy.items.splice(index, 1, newItem);
          }
        });

        const keyMap = new Map();

        this.existing.renewableEnergy.items
          .filter((data) => !data.deleted && data.type)
          .forEach((item, index) => {
            const key = `${item.type.id}`;
            if (!keyMap.has(key)) {
              keyMap.set(key, []);
            }
            keyMap.get(key).push(index);
          });

        this.existing.renewableEnergy.items
          .filter((data) => !data.deleted && data.type)
          .forEach((item) => {
            const key = `${item.type.id}`;
            const duplicateIndexes = keyMap.get(key);
            item.duplicate = duplicateIndexes.length > 1;
          });

        this.calculateRowValid(3);
      },
      deep: true,
    },
    "dataTableEquipment.items": {
      handler(newItems) {
        newItems.forEach((item) => {
          const index = item.existing_index;

          if (index !== undefined && this.existing.equipment.items[index]) {
            const newItem = { ...item };
            delete newItem.existing_index;
            this.existing.equipment.items.splice(index, 1, newItem);
          }
        });

        const keyMap = new Map();

        this.existing.equipment.items
          .filter((data) => !data.deleted && data.equipment)
          .forEach((item, index) => {
            const key = `${item.equipment.id}`;
            if (!keyMap.has(key)) {
              keyMap.set(key, []);
            }
            keyMap.get(key).push(index);
          });

        this.existing.equipment.items
          .filter((data) => !data.deleted && data.equipment)
          .forEach((item) => {
            const key = `${item.equipment.id}`;
            const duplicateIndexes = keyMap.get(key);
            item.duplicate = duplicateIndexes.length > 1;
          });

        this.calculateRowValid(4);
      },
      deep: true,
    },
    production: {
      handler() {
        this.setValid();
      },
      deep: true,
    },
    $route: {
      handler() {
        this.loadPage();
      },
      deep: true,
    },
  },
  methods: {
    download,
    async loadPage() {
      this.workArea = this.$route.params.workArea;

      if (this.workArea === WorkAreaEnum.HAULING) {
        this.typeConsume = this.typeConsume.map((item) => ({
          ...item,
          show: true,
        }));

        this.typeConsumeActive = 5;
      }

      if (!this.isAdmin && !Array.isArray(this.userData.role)) {
        this.kontraktorID = this.userData.kontraktorID;
        this.filled_by = this.userData.email;

        const isAreaValid = this.userData.workArea
          ? this.userData.workArea
              .replace("[", "")
              .replace("]", "")
              .split(",")
              .map((item) => item.trim())
              .some((item) => item == this.$route.params.workArea)
          : null;

        if (!isAreaValid) {
          this.$router.push({ path: "/esg-report", query: this.$route.query });
        }
      }

      this.year = this.$route.params.year;

      await this.getMonthById(this.$route.params.id_month);

      this.idEsg = null;
      if (this.$route.params.id_contractor && this.$route.params.id_sub) {
        this.idEsg = this.$route.params.id_sub;
      } else if (!this.$route.params.id_contractor && this.$route.params.id) {
        this.idEsg = this.$route.params.id;
      }

      await this.setTabSummary(this.$route.params.id);

      if (this.idEsg) {
        await this.getEsgDetil(this.idEsg);
      } else {
        this.displayData = !this.userData.isPjo && parseInt(this.year) >= 2025;

        this.existing.lastSaved = null;
        this.existing.approved_by = null;
        this.existing.note = null;

        this.status = null;

        this.production.coal_production = null;
        this.production.ob_production = null;

        this.existing.equipment.items = [];
        this.existing.equipment.page = 1;
        this.existing.equipment.total_per_page = 5;
        this.existing.equipment.total_data = 0;

        this.existing.fuel.items = [];
        this.existing.fuel.page = 1;
        this.existing.fuel.total_per_page = 5;
        this.existing.fuel.total_data = 0;

        this.existing.electric.items = [];
        this.existing.electric.page = 1;
        this.existing.electric.total_per_page = 5;
        this.existing.electric.total_data = 0;

        this.existing.renewableEnergy.items = [];
        this.existing.renewableEnergy.page = 1;
        this.existing.renewableEnergy.total_per_page = 5;
        this.existing.renewableEnergy.total_data = 0;

        if (this.workArea === WorkAreaEnum.HAULING) {
          this.addRowEquipment(typeEquipmentEnum.BERGERAK);
        }

        this.addRowFuel();
        this.addRowElectric();
        this.addRowRenewableEnergy();

        if (this.$route.params?.id_contractor && !this.isAdmin) {
          this.kontraktorID = this.$route.params.id_contractor;
        }

        this.detilContractor(this.kontraktorID);
      }

      if (this.$route.params.id) {
        this.url_navlink = `/esg-report/${this.year}/${this.month.id}/${this.workArea}/${this.$route.params.id}`;
      } else {
        this.url_navlink = null;
      }
    },
    async addRowFuel() {
      const formData = cloneDeep(FormCreateDataEsgFormFuel);
      const uuid = crypto.randomUUID();

      Object.assign(formData, { uuid });

      this.existing.fuel.items.unshift(formData);
      this.existing.fuel.totalItems = this.existing.fuel.items.filter(
        (item) => !item.deleted
      ).length;

      this.existing.fuel.page = 1;

      const perPage = this.existing.fuel.perPage;
      const startIndex = 0;

      this.dataTableFuel.items = this.existing.fuel.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + perPage);

      this.dataTableFuel.start_index = startIndex;

      await this.getFuel(null, uuid);
    },
    async addRowElectric() {
      const formData = cloneDeep(FormCreateDataEsgFormElectric);
      const uuid = crypto.randomUUID();

      Object.assign(formData, { uuid });

      this.existing.electric.items.unshift(formData);
      this.existing.electric.totalItems = this.existing.electric.items.filter(
        (item) => !item.deleted
      ).length;

      this.existing.electric.page = 1;

      const perPage = this.existing.electric.perPage;
      const startIndex = 0;

      this.dataTableElectric.items = this.existing.electric.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + perPage);

      this.dataTableElectric.start_index = startIndex;

      await this.getElectric(null, uuid);
    },
    async addRowRenewableEnergy() {
      const formData = cloneDeep(FormCreateDataEsgFormRenewableEnergy);
      const uuid = crypto.randomUUID();

      Object.assign(formData, { uuid });

      this.existing.renewableEnergy.items.unshift(formData);
      this.existing.renewableEnergy.totalItems =
        this.existing.renewableEnergy.items.filter(
          (item) => !item.deleted
        ).length;

      this.existing.renewableEnergy.page = 1;

      const perPage = this.existing.renewableEnergy.perPage;
      const startIndex = 0;

      this.dataTableRenewableEnergy.items = this.existing.renewableEnergy.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + perPage);

      this.dataTableRenewableEnergy.start_index = startIndex;

      await this.getRenewableEnergy(null, uuid);
    },
    async addRowEquipment(type) {
      const formData = cloneDeep(FormCreateDataEsgFormEquipment);
      const uuid = crypto.randomUUID();

      Object.assign(formData, { uuid, type_equipment: type });

      this.existing.equipment.items.unshift(formData);
      this.existing.equipment.totalItems = this.existing.equipment.items.filter(
        (item) => !item.deleted && item.type_equipment === type
      ).length;

      this.existing.fuel.page = 1;

      const perPage = this.existing.fuel.perPage;
      const startIndex = 0;

      this.dataTableEquipment.items = this.existing.equipment.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted && item.type_equipment === type)
        .slice(startIndex, startIndex + perPage);

      this.dataTableEquipment.start_index = startIndex;

      await this.getEquipment(null, type, uuid);
    },
    async getMonthById(id) {
      try {
        const result = await axios.get(`${base_url}/month/detail/${id}`);
        this.month = result.data.data;
      } catch (err) {
        util.showError(err);
      }
    },
    changeTypeActive(type) {
      this.typeConsumeActive = type;
    },
    loading(status) {
      this.isLoading = status;
    },
    async fetchData() {},
    removeRowFuel(existing_index) {
      const page = this.existing.fuel.page;
      const perPage = this.existing.fuel.perPage;
      this.existing.fuel.items = this.existing.fuel.items.map((item, index) => {
        if (index === existing_index) {
          item.deleted = true;
          item.changed = true;
        }
        return item;
      });

      this.existing.fuel.totalItems =
        this.existing.fuel.items.filter((item) => !item.deleted).length ?? 0;

      this.dataTableFuel.items = this.existing.fuel.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice((page - 1) * perPage, page * perPage);
    },
    removeRowElectric(existing_index) {
      const page = this.existing.electric.page;
      const perPage = this.existing.electric.perPage;
      this.existing.electric.items = this.existing.electric.items.map(
        (item, index) => {
          if (index === existing_index) {
            item.deleted = true;
            item.changed = true;
          }
          return item;
        }
      );

      this.existing.electric.totalItems =
        this.existing.electric.items.filter((item) => !item.deleted).length ??
        0;

      this.dataTableElectric.items = this.existing.electric.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice((page - 1) * perPage, page * perPage);
    },
    removeRowRenewableEnergy(existing_index) {
      const page = this.existing.renewableEnergy.page;
      const perPage = this.existing.renewableEnergy.perPage;
      this.existing.renewableEnergy.items =
        this.existing.renewableEnergy.items.map((item, index) => {
          if (index === existing_index) {
            item.deleted = true;
            item.changed = true;
          }
          return item;
        });

      this.existing.renewableEnergy.totalItems =
        this.existing.renewableEnergy.items.filter((item) => !item.deleted)
          .length ?? 0;

      this.dataTableRenewableEnergy.items = this.existing.renewableEnergy.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice((page - 1) * perPage, page * perPage);
    },
    removeRowEquipment(existing_index, type) {
      const page = this.existing.equipment.page;
      const perPage = this.existing.equipment.perPage;
      this.existing.equipment.items = this.existing.equipment.items
        .filter((item) => item.type_equipment === type)
        .map((item, index) => {
          if (index === existing_index) {
            item.deleted = true;
            item.changed = true;
          }
          return item;
        });

      this.existing.equipment.totalItems =
        this.existing.equipment.items.filter(
          (item) => !item.deleted && item.type_equipment === type
        ).length ?? 0;

      this.dataTableEquipment.items = this.existing.equipment.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted && item.type_equipment === type)
        .slice((page - 1) * perPage, page * perPage);
    },
    changeTypeEquipment(type) {
      this.existing.equipment.totalItems = this.existing.equipment.items.filter(
        (item) => !item.deleted && item.type_equipment === type
      ).length;

      this.existing.fuel.page = 1;

      const perPage = this.existing.fuel.perPage;
      const startIndex = 0;

      this.dataTableEquipment.items = this.existing.equipment.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted && item.type_equipment === type)
        .slice(startIndex, startIndex + perPage);

      this.dataTableEquipment.start_index = startIndex;
    },
    getEquipment: debounce(function (keyword, type, uuid, size = 10) {
      const uuids = Array.isArray(uuid) ? uuid : [{ uuid: uuid, used: false }];
      uuids.forEach((id) => {
        this.loadingEquipment[id.uuid] = true;
      });
      axios
        .get(`${base_url}/equipment`, {
          params: {
            page: 1,
            size: size,
            name: keyword?.trim(),
            type: type,
            active: true,
            sortBy: {
              key: "name",
              order: "ASC",
            },
          },
        })
        .then((res) => {
          const result = res.data.data.map((item) => {
            return {
              title: item.name,
              value: item,
            };
          });

          if (type) {
            uuids.forEach((id) => {
              const existingIndex = this.listEquipment.findIndex(
                (i) => i?.uuid === id.uuid
              );

              const newItem = { uuid: id.uuid, value: result };

              if (existingIndex !== -1) {
                if (id.used) {
                  const existingData = result.some(
                    (item) =>
                      item.value.id ===
                      this.listEquipment[existingIndex].value[0].value.id
                  );
                  if (existingData) {
                    // update list while keep existing selected value title
                    this.listEquipment[existingIndex] = {
                      uuid: id.uuid,
                      value: result.map((item) => ({
                        title:
                          this.listEquipment[existingIndex].value[0].value
                            .id === item.value.id
                            ? this.listEquipment[existingIndex].value[0].title
                            : item.title,
                        value:
                          this.listEquipment[existingIndex].value[0].value
                            .id === item.value.id
                            ? this.listEquipment[existingIndex].value[0].value
                            : item.value,
                      })),
                    };
                  } else {
                    // setup to keep existing selected value when data not found
                    this.listEquipment[existingIndex] = {
                      ...newItem,
                      value: [
                        ...newItem.value,
                        this.listEquipment[existingIndex].value[0],
                      ].sort((a, b) =>
                        a.value.name.localeCompare(b.value.name)
                      ),
                    };
                  }
                } else {
                  // just update the list
                  this.listEquipment[existingIndex] = newItem;
                }
              } else {
                // add new to the list
                this.listEquipment.push(newItem);
              }
            });
          }
          setTimeout(() => {
            uuids.forEach((id) => {
              this.loadingEquipment[id.uuid] = false;
            });
          }, 1000);
        })
        .catch((err) => {
          uuids.forEach((id) => {
            this.loadingEquipment[id.uuid] = false;
          });
          util.showError(err);
        });
    }, 500),
    getFuel: debounce(function (keyword, uuid, size = 10) {
      axios
        .get(`${base_url}/fuel`, {
          params: {
            page: 1,
            size: size,
            name: keyword?.trim(),
            active: true,
            sys_config: true,
            sortBy: {
              key: "name",
              order: "ASC",
            },
          },
        })
        .then((res) => {
          const result = res.data.data.map((item) => ({
            title: item.name,
            value: {
              id: item.id,
              name: item.name,
              active: item.active,
            },
          }));

          const uuids = Array.isArray(uuid)
            ? uuid
            : [{ uuid: uuid, used: false }];

          uuids.forEach((id) => {
            const existingIndex = this.listFuel.findIndex(
              (i) => i?.uuid === id.uuid
            );

            const newItem = { uuid: id.uuid, value: result };

            if (existingIndex !== -1) {
              if (id.used) {
                const existingData = result.some(
                  (item) =>
                    item.value.id ===
                    this.listFuel[existingIndex].value[0].value.id
                );
                if (existingData) {
                  // update list while keep existing selected value title
                  this.listFuel[existingIndex] = {
                    uuid: id.uuid,
                    value: result.map((item) => ({
                      title:
                        this.listFuel[existingIndex].value[0].value.id ===
                        item.value.id
                          ? this.listFuel[existingIndex].value[0].title
                          : item.title,
                      value:
                        this.listFuel[existingIndex].value[0].value.id ===
                        item.value.id
                          ? this.listFuel[existingIndex].value[0].value
                          : item.value,
                    })),
                  };
                } else {
                  // setup to keep existing selected value when data not found
                  this.listFuel[existingIndex] = {
                    ...newItem,
                    value: [
                      ...newItem.value,
                      this.listFuel[existingIndex].value[0],
                    ].sort((a, b) => a.value.name.localeCompare(b.value.name)),
                  };
                }
              } else {
                // just update the list
                this.listFuel[existingIndex] = newItem;
              }
            } else {
              // add new to the list
              this.listFuel.push(newItem);
            }
          });
        })
        .catch((err) => {
          util.showError(err);
          console.log({ err });
        });
    }, 500),
    getElectric: debounce(function (keyword, uuid, size = 10) {
      axios
        .get(`${base_url}/electric`, {
          params: {
            page: 1,
            size: size,
            name: keyword?.trim(),
            active: true,
            sortBy: {
              key: "name",
              order: "ASC",
            },
          },
        })
        .then((res) => {
          const result = res.data.data.map((item) => {
            return {
              title: item.name,
              value: item,
            };
          });

          const uuids = Array.isArray(uuid)
            ? uuid
            : [{ uuid: uuid, used: false }];

          uuids.forEach((id) => {
            const existingIndex = this.listElektric.findIndex(
              (i) => i?.uuid === id.uuid
            );
            const newItem = { uuid: id.uuid, value: result };

            if (existingIndex !== -1) {
              if (id.used) {
                const existingData = result.some(
                  (item) =>
                    item.value.id ===
                    this.listElektric[existingIndex].value[0].value.id
                );
                if (existingData) {
                  // update list while keep existing selected value title
                  this.listElektric[existingIndex] = {
                    uuid: id.uuid,
                    value: result.map((item) => ({
                      title:
                        this.listElektric[existingIndex].value[0].value.id ===
                        item.value.id
                          ? this.listElektric[existingIndex].value[0].title
                          : item.title,
                      value:
                        this.listElektric[existingIndex].value[0].value.id ===
                        item.value.id
                          ? this.listElektric[existingIndex].value[0].value
                          : item.value,
                    })),
                  };
                } else {
                  // setup to keep existing selected value when data not found
                  this.listElektric[existingIndex] = {
                    ...newItem,
                    value: [
                      ...newItem.value,
                      this.listElektric[existingIndex].value[0],
                    ].sort((a, b) => a.value.name.localeCompare(b.value.name)),
                  };
                }
              } else {
                // just update the list
                this.listElektric[existingIndex] = newItem;
              }
            } else {
              // add new to the list
              this.listElektric.push(newItem);
            }
          });
        })
        .catch((err) => {
          util.showError(err);
        });
    }, 500),
    getRenewableEnergy: debounce(function (keyword, uuid, size = 10) {
      axios
        .get(`${base_url}/renewable-energy`, {
          params: {
            page: 1,
            size: size,
            name: keyword?.trim(),
            active: true,
            sortBy: {
              key: "name",
              order: "ASC",
            },
          },
        })
        .then((res) => {
          const result = res.data.data.map((item) => {
            return {
              title: item.name,
              value: item,
            };
          });

          const uuids = Array.isArray(uuid)
            ? uuid
            : [{ uuid: uuid, used: false }];

          uuids.forEach((id) => {
            const existingIndex = this.listRenewableEnergy.findIndex(
              (i) => i?.uuid === id.uuid
            );
            const newItem = { uuid: id.uuid, value: result };

            if (existingIndex !== -1) {
              if (id.used) {
                const existingData = result.some(
                  (item) =>
                    item.value.id ===
                    this.listRenewableEnergy[existingIndex].value[0].value.id
                );
                if (existingData) {
                  // update list while keep existing selected value title
                  this.listRenewableEnergy[existingIndex] = {
                    uuid: id.uuid,
                    value: result.map((item) => ({
                      title:
                        this.listRenewableEnergy[existingIndex].value[0].value
                          .id === item.value.id
                          ? this.listRenewableEnergy[existingIndex].value[0]
                              .title
                          : item.title,
                      value:
                        this.listRenewableEnergy[existingIndex].value[0].value
                          .id === item.value.id
                          ? this.listRenewableEnergy[existingIndex].value[0]
                              .value
                          : item.value,
                    })),
                  };
                } else {
                  // setup to keep existing selected value when data not found
                  this.listRenewableEnergy[existingIndex] = {
                    ...newItem,
                    value: [
                      ...newItem.value,
                      this.listRenewableEnergy[existingIndex].value[0],
                    ].sort((a, b) => a.value.name.localeCompare(b.value.name)),
                  };
                }
              } else {
                // just update the list
                this.listRenewableEnergy[existingIndex] = newItem;
              }
            } else {
              // add new to the list
              this.listRenewableEnergy.push(newItem);
            }
          });
        })
        .catch((err) => {
          util.showError(err);
        });
    }, 500),
    handleInput(event, column, index) {
      let textField = event.target;
      if (!textField) return;

      let cursorPosition = textField.selectionStart;
      let formattedValue;
      if (
        column === "unit" ||
        column === "unit_renewable_energy" ||
        column === "unit_electric"
      ) {
        formattedValue = formatNumberOnly(textField.value);
      } else {
        formattedValue = formatNumber(textField.value);
      }

      let lengthDiff = formattedValue.length - textField.value.length;
      let newCursorPosition = cursorPosition + lengthDiff;

      if (column === "ob_production") {
        this.production.ob_production = formattedValue;
      } else if (column === "coal_production") {
        this.production.coal_production = formattedValue;
      } else if (column === "volume") {
        this.dataTableFuel.items[index].volume = formattedValue;
      } else if (column === "distance") {
        this.dataTableFuel.items[index].distance = formattedValue;
      } else if (column === "unit_electric") {
        this.dataTableElectric.items[index].unit = formattedValue;
      } else if (column === "total_electric") {
        this.dataTableElectric.items[index].total = formattedValue;
      } else if (column === "unit_renewable_energy") {
        this.dataTableRenewableEnergy.items[index].unit = formattedValue;
      } else if (column === "consume_renewable_energy") {
        this.dataTableRenewableEnergy.items[index].consume = formattedValue;
      } else if (column === "total_renewable_energy") {
        this.dataTableRenewableEnergy.items[index].total = formattedValue;
      } else if (column === "unit") {
        this.dataTableEquipment.items[index].unit = formattedValue;
      }

      this.$nextTick(() => {
        textField.setSelectionRange(newCursorPosition, newCursorPosition);
      });
    },
    closeModal() {
      this.tabs = this.tabs.map((item, index) => ({
        ...item,
        active:
          this.tabs.length === 1 && index === 0
            ? true
            : item.id === parseInt(this.idEsg)
            ? true
            : false,
      }));
      this.dialogSubmission = false;
      this.dialogApprove = false;
      this.dialogSummary = false;
      this.dialogGenerateFileValidity = false;
      this.formDataSummary = {};
      this.pjo = {};
    },
    async calculateSummary(id = null) {
      try {
        this.setLoadingSummary(true);

        let bodyJson = {};

        if (
          // 1. status draft/revision dan id null/sama dengan idEsg
          ((this.status === StatusEnum.DRAFT ||
            this.status === StatusEnum.REVISION) &&
            (id === null || parseInt(id) === parseInt(this.idEsg))) ||
          // 2. status null & idEsg null
          (this.status === null && this.idEsg === null)
        ) {
          bodyJson = {
            production_ob: this.production.ob_production ?? "0",
            production_coal: this.production.coal_production ?? "0",
            area: this.workArea,
            id_month: parseInt(this.month.id),
            esg_fuel: this.existing.fuel.items
              .filter((item) => item.id || (!item.id && !item.deleted))
              .filter((item) => {
                const idFuel = item.fuel?.id;
                const volume = item.volume;
                return (
                  idFuel !== undefined &&
                  idFuel !== null &&
                  volume !== undefined &&
                  volume !== null &&
                  volume !== "" &&
                  volume?.trim() !== ""
                );
              })
              .map((data) => ({
                type_equipment: data.type_equipment,
                id_fuel: data.fuel?.id,
                volume: data.volume,
              })),
            esg_electric: this.existing.electric.items
              .filter((item) => item.id || (!item.id && !item.deleted))
              .filter((item) => {
                const idElectric = item.electric?.id;
                const total = item.total;
                return (
                  idElectric !== undefined &&
                  idElectric !== null &&
                  total !== undefined &&
                  total !== null &&
                  total !== "" &&
                  total?.trim() !== ""
                );
              })
              .map((data) => ({
                id_electric: data.electric?.id,
                total: data.total,
              })),
            esg_renewable_energy: this.existing.renewableEnergy.items
              .filter((item) => item.id || (!item.id && !item.deleted))
              .filter((item) => {
                const idRenewable = item.type?.id;
                const consume = item.consume;
                return (
                  idRenewable !== undefined &&
                  idRenewable !== null &&
                  consume !== undefined &&
                  consume !== null &&
                  consume !== "" &&
                  consume?.trim() !== ""
                );
              })
              .map((data) => ({
                consume: data.consume,
                id_renewable_energy: data.type?.id,
              })),
            esg_equipment: this.existing.equipment.items
              .filter((item) => item.id || (!item.id && !item.deleted))
              .filter((item) => {
                const idEquipment = item.equipment?.id;
                const unit = item.unit;
                return (
                  idEquipment !== undefined &&
                  idEquipment !== null &&
                  typeof unit === "number" &&
                  !isNaN(unit)
                );
              })
              .map((data) => ({
                unit: data.unit,
                id_equipment: data.equipment?.id,
              })),
          };
        } else {
          const idData = id ?? this.idEsg;
          bodyJson = {
            id: parseInt(idData),
          };
        }
        const res = await axios.post(`${base_url}/esg/summary`, bodyJson);

        this.dialogSummary = true;
        this.formDataSummary = res.data.data;

        const itemId = id ?? this.idEsg;

        if (itemId) {
          const data = await axios.get(`${base_url}/esg/detail/${itemId}`);

          const response = data.data.data;
          Object.assign(this.formDataSummary, {
            id: itemId,
            id_contractor: response.id_contractor,
            contractor_name: response.contractor_name,
            month: response.master_month.name,
            year: response.master_year.name,
            status: response.status,
            area: response.area,
          });
        }
      } catch (err) {
        util.showError(err);
      } finally {
        this.setLoadingSummary(false);
      }
    },
    async downloadExcel() {
      try {
        let bodyJson = {
          id: parseInt(this.$route.params.id),
          is_pjo: this.userData.isPjo ?? false,
          is_contractor: !Array.isArray(this.userData.role),
          mode: "COMBINED",
        };

        let filename =
          this.month.name + "_" + this.year + "_" + this.kontraktorName;

        downloadReportESG(filename, bodyJson);
      } catch (err) {
        util.showError(err);
      }
    },
    setLoading(status) {
      this.existing.fuel.loading = status;
      this.existing.electric.loading = status;
      this.existing.renewableEnergy.loading = status;
      this.existing.equipment.loading = status;
    },
    setLoadingSummary(status) {
      this.loadingSummary = status;
    },
    fetchDataFuel(page = 1, itemsPerPage = 10) {
      this.existing.fuel.page = page;
      this.existing.fuel.perPage = itemsPerPage;

      const startIndex = (page - 1) * itemsPerPage;

      this.dataTableFuel.items = this.existing.fuel.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + itemsPerPage);

      this.dataTableFuel.start_index = startIndex;
    },
    fetchDataElectric(page = 1, itemsPerPage = 10) {
      this.existing.electric.page = page;
      this.existing.electric.perPage = itemsPerPage;

      const startIndex = (page - 1) * itemsPerPage;

      this.dataTableElectric.items = this.existing.electric.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + itemsPerPage);

      this.dataTableElectric.start_index = startIndex;
    },
    fetchDataRenewableEnergy(page = 1, itemsPerPage = 10) {
      this.existing.renewableEnergy.page = page;
      this.existing.renewableEnergy.perPage = itemsPerPage;

      const startIndex = (page - 1) * itemsPerPage;

      this.dataTableRenewableEnergy.items = this.existing.renewableEnergy.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + itemsPerPage);

      this.dataTableRenewableEnergy.start_index = startIndex;
    },
    fetchDataEquipment(page = 1, itemsPerPage = 10, type) {
      this.existing.equipment.page = page;
      this.existing.equipment.perPage = itemsPerPage;

      const startIndex = (page - 1) * itemsPerPage;

      this.dataTableEquipment.items = this.existing.equipment.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted && item.type_equipment === type)
        .slice(startIndex, startIndex + itemsPerPage);

      this.dataTableEquipment.start_index = startIndex;
    },
    fuelSearch(keyword) {
      keyword = keyword?.trim();

      const results = Array.isArray(this.existing.fuel.items)
        ? this.existing.fuel.items
            .map((data, index) => ({ ...data, existing_index: index }))
            .filter(
              (item) =>
                !item.deleted &&
                (item.equipment?.name
                  ?.toLowerCase()
                  .includes(keyword?.toLowerCase()) ||
                  item.fuel?.name
                    ?.toLowerCase()
                    .includes(keyword?.toLowerCase()))
            )
        : [];

      const startIndex = this.dataTableFuel.start_index;
      const perPage = this.existing.fuel.perPage;
      if (keyword) {
        this.dataTableFuel.items = results.slice(
          startIndex,
          startIndex + perPage
        );
        this.existing.fuel.totalItems = results.length;
      } else {
        this.dataTableFuel.items = this.existing.fuel.items
          .map((data, index) => ({ ...data, existing_index: index }))
          .filter((item) => !item.deleted)
          .slice(startIndex, startIndex + perPage);
        this.existing.fuel.totalItems = this.existing.fuel.items.filter(
          (item) => !item.deleted
        ).length;
      }
    },
    electricSearch(keyword) {
      keyword = keyword?.trim();

      const results = Array.isArray(this.existing.electric.items)
        ? this.existing.electric.items
            .map((data, index) => ({ ...data, existing_index: index }))
            .filter(
              (item) =>
                !item.deleted &&
                item.electric?.name
                  ?.toLowerCase()
                  .includes(keyword?.toLowerCase())
            )
        : [];

      const startIndex = this.dataTableElectric.start_index;
      const perPage = this.existing.electric.perPage;
      if (keyword) {
        this.dataTableElectric.items = results.slice(
          startIndex,
          startIndex + perPage
        );
        this.existing.electric.totalItems = results.length;
      } else {
        this.dataTableElectric.items = this.existing.electric.items
          .map((data, index) => ({ ...data, existing_index: index }))
          .filter((item) => !item.deleted)
          .slice(startIndex, startIndex + perPage);
        this.existing.electric.totalItems = this.existing.electric.items.filter(
          (item) => !item.deleted
        ).length;
      }
    },
    renewableEnergySearch(keyword) {
      keyword = keyword?.trim();

      const results = Array.isArray(this.existing.renewableEnergy.items)
        ? this.existing.renewableEnergy.items
            .map((data, index) => ({ ...data, existing_index: index }))
            .filter(
              (item) =>
                !item.deleted &&
                item.type?.name?.toLowerCase().includes(keyword?.toLowerCase())
            )
        : [];

      const startIndex = this.dataTableRenewableEnergy.start_index;
      const perPage = this.existing.renewableEnergy.perPage;
      if (keyword) {
        this.dataTableRenewableEnergy.items = results.slice(
          startIndex,
          startIndex + perPage
        );
        this.existing.renewableEnergy.totalItems = results.length;
      } else {
        this.dataTableRenewableEnergy.items =
          this.existing.renewableEnergy.items
            .map((data, index) => ({ ...data, existing_index: index }))
            .filter((item) => !item.deleted)
            .slice(startIndex, startIndex + perPage);
        this.existing.renewableEnergy.totalItems =
          this.existing.renewableEnergy.items.filter(
            (item) => !item.deleted
          ).length;
      }
    },
    equipmentSearch(keyword, type) {
      keyword = keyword?.trim();

      const results = Array.isArray(this.existing.equipment.items)
        ? this.existing.equipment.items
            .map((data, index) => ({ ...data, existing_index: index }))
            .filter(
              (item) =>
                !item.deleted &&
                item.type_equipment === type &&
                item.equipment?.name
                  ?.toLowerCase()
                  .includes(keyword?.toLowerCase())
            )
        : [];

      const startIndex = this.dataTableEquipment.start_index;
      const perPage = this.existing.equipment.perPage;
      if (keyword) {
        this.dataTableEquipment.items = results.slice(
          startIndex,
          startIndex + perPage
        );
        this.existing.equipment.totalItems = results.length;
      } else {
        this.dataTableEquipment.items = this.existing.equipment.items
          .map((data, index) => ({ ...data, existing_index: index }))
          .filter((item) => !item.deleted)
          .slice(startIndex, startIndex + perPage);
        this.existing.equipment.totalItems =
          this.existing.equipment.items.filter((item) => !item.deleted).length;
      }
    },
    calculateRowValid(tabActive) {
      this.typeConsume.forEach((item) => {
        item.type.forEach((data) => {
          if (tabActive === data.id && tabActive === 1) {
            const fuelItems = this.existing.fuel.items.filter(
              (dta) => !dta.deleted
            );

            data.countType = fuelItems.length;
            data.typeFilled = fuelItems.filter((itm) => {
              const isNonMovable =
                itm.type_equipment === typeEquipmentEnum.TIDAK_BERGERAK;

              return (
                !this.getErrors(
                  this.formValidasiFuel.type_equipment,
                  itm.type_equipment
                ).length &&
                !this.getErrors(this.formValidasiFuel.fuel, itm.fuel).length &&
                !this.getErrors(this.formValidasiFuel.volume, itm.volume)
                  .length &&
                (isNonMovable ||
                  !this.getErrors(this.formValidasiFuel.distance, itm.distance)
                    .length)
              );
            }).length;
          } else if (tabActive === data.id && tabActive === 2) {
            const electricItems = this.existing.electric.items.filter(
              (dta) => !dta.deleted
            );
            data.countType = electricItems.length;
            data.typeFilled = electricItems.filter((itm) => {
              const noErrorElectric = !this.getErrors(
                this.formValidasiElectric.electric,
                itm.electric
              ).length;
              const noErrorTotal = !this.getErrors(
                this.formValidasiElectric.total,
                itm.total
              ).length;

              const requireUnitValid = itm.electric?.is_unit
                ? !this.getErrors(this.formValidasiElectric.unit, itm.unit)
                    .length
                : true;

              const requireFileValid = itm.electric?.is_file
                ? !this.getErrors(this.formValidasiElectric.file, itm.file)
                    .length
                : true;

              return (
                noErrorElectric &&
                noErrorTotal &&
                requireUnitValid &&
                requireFileValid
              );
            }).length;
          } else if (tabActive === data.id && tabActive === 3) {
            const renewableItems = this.existing.renewableEnergy.items.filter(
              (dta) => !dta.deleted
            );
            data.countType = renewableItems.length;
            data.typeFilled = renewableItems.filter((itm) => {
              return (
                !this.getErrors(this.formValidasiRenewableEnergy.type, itm.type)
                  .length &&
                !this.getErrors(
                  this.formValidasiRenewableEnergy.consume,
                  itm.consume
                ).length
              );
            }).length;
          }
        });
      });
      this.setValid();
    },
    getErrors(rules, value) {
      const errors = rules
        .map((rule) => rule(value))
        .filter((result) => result !== true);
      return errors;
    },
    setValid() {
      // 1. Cek duplikasi di semua tab
      const checkDuplicate =
        this.existing.fuel.items.some(
          (item) => item.duplicate && !item.deleted
        ) ||
        this.existing.electric.items.some(
          (item) => item.duplicate && !item.deleted
        ) ||
        this.existing.renewableEnergy.items.some(
          (item) => item.duplicate && !item.deleted
        ) ||
        this.existing.equipment.items.some(
          (item) => item.duplicate && !item.deleted
        );

      // 2. Filter hanya item aktif (tidak dihapus)
      const fuelItems = this.existing.fuel.items.filter(
        (item) => !item.deleted
      );
      const electricItems = this.existing.electric.items.filter(
        (item) => !item.deleted
      );
      const renewableItems = this.existing.renewableEnergy.items.filter(
        (item) => !item.deleted
      );
      const unitItems = this.existing.equipment.items.filter(
        (item) => !item.deleted
      );

      // 3. Validasi fuel tab
      const isFuelValid =
        (this.workArea === WorkAreaEnum.HAULING && unitItems.length > 0
          ? fuelItems.length > 0
          : true) &&
        (fuelItems.length === 0 ||
          fuelItems.every((item) => {
            // Kasus 1: semua field terisi
            const baseFilled = item.type_equipment && item.fuel && item.volume;
            const movementCheckFilled =
              item.type_equipment === typeEquipmentEnum.BERGERAK
                ? item.distance
                : true;
            const isFilledValid = baseFilled && movementCheckFilled;

            // Kasus 2: semua field kosong (artinya pengguna belum mulai isi)
            const baseEmpty =
              !item.type_equipment && !item.fuel && !item.volume;
            const movementCheckEmpty =
              item.type_equipment === typeEquipmentEnum.BERGERAK
                ? !item.distance
                : true;

            const isEmptyValid = baseEmpty && movementCheckEmpty;

            // Return valid jika item ini sepenuhnya valid atau sepenuhnya kosong
            return isFilledValid || isEmptyValid;
          }));

      // 4. Validasi electric tab
      const isElectricValid =
        electricItems.length === 0 ||
        electricItems.every((item) => {
          const isEmptyValid = !item.electric && !item.total;
          const isFilledValid = item.electric && item.total;

          const isUnit = item.electric?.is_unit;
          const isFile = item.electric?.is_file;
          const hasUnit = !!item.unit;
          const hasFile = !!(item.file || item.url_file);

          // Jika tidak diisi, dianggap valid
          if (isEmptyValid) return true;

          // Jika diisi, pastikan semua field tambahan valid
          if (isFilledValid) {
            if (isUnit && !hasUnit) return false;
            if (isFile && !hasFile) return false;
            return true;
          }

          // Jika hanya salah satu dari electric/total yang diisi, tidak valid
          return false;
        });

      // 5. Validasi renewable tab
      const isRenewableValid =
        renewableItems.length === 0 ||
        renewableItems.every((item) => {
          const isFilledValid = !item.type && !item.consume;
          const isEmptyValid = item.type && item.consume;
          return isFilledValid || isEmptyValid;
        });

      // 6. Validasi unit untuk workArea Hauling
      const isHaulingValid =
        this.workArea !== WorkAreaEnum.HAULING ||
        (unitItems.length > 0 &&
          unitItems.every((item) => item.unit && item.equipment));

      // 7. Validasi typeConsume: cukup salah satu yang valid
      const isTypeConsumeValid = this.typeConsume[1].type.some(
        (item) =>
          item.countType === item.typeFilled &&
          item.countType !== 0 &&
          item.typeFilled !== 0
      );

      // 8. Validasi input production
      const isFormValid =
        this.workArea === WorkAreaEnum.MINING
          ? !this.getErrors(
              this.formValidasiFuel.ob_production,
              this.production.ob_production
            ).length &&
            !this.getErrors(
              this.formValidasiFuel.coal_production,
              this.production.coal_production
            ).length
          : this.workArea !== WorkAreaEnum.OTHERS
          ? !this.getErrors(
              this.formValidasiFuel.coal_production,
              this.production.coal_production
            ).length
          : true;

      // 9. FINAL: Set isValid
      this.isValid =
        isTypeConsumeValid &&
        !checkDuplicate &&
        isFormValid &&
        isFuelValid &&
        isElectricValid &&
        isRenewableValid &&
        isHaulingValid;

      const isSubValid = this.subContractor?.length
        ? this.subContractor.every((item) => item.valid === 1)
        : true;
      if (this.isAdmin) {
        this.isSubmit = this.isValid;
      } else {
        this.isSubmit = this.isValid && isSubValid;
      }
    },
    async getEsgDetil(id) {
      try {
        this.setLoading(true);
        const res = await axios.get(`${base_url}/esg/detail/${id}`);
        const data = res.data.data;
        this.status = data.status;
        if (this.isAdmin || Array.isArray(this.userData.role)) {
          this.filled_by = this.userData.name;
          this.kontraktorName = data.contractor_name;
          this.subContractor = data.sub_contractor;

          this.isSubmit = this.isValid;
        } else {
          if (
            this.status === StatusEnum.COMPLETED ||
            this.status === StatusEnum.WAITING_APPROVAL
          ) {
            this.kontraktorName = data.contractor_name;
            this.subContractor = data.sub_contractor;
          } else {
            this.detilContractor(data.id_contractor);
          }
        }
        this.tabs = this.tabs.map((item) => ({
          ...item,
          name: item.id == id ? data.contractor_name : item.name,
          active: item.id == id ? true : false,
        }));

        this.workArea = data.area;
        this.kontraktorID = data.id_contractor;
        this.initials = data.initials;
        this.file_validity = data.file_validity;

        if (this.userData.isPjo) {
          this.displayData = this.status
            ? this.status === StatusEnum.DRAFT
              ? false
              : true
            : false;
        } else {
          this.displayData = true;
        }

        this.production.coal_production = data.production_coal;
        this.production.ob_production = data.production_ob;
        this.existing.note = data.note;

        this.dataTableEquipment.items = [];
        this.dataTableFuel.items = [];
        this.dataTableElectric.items = [];
        this.dataTableRenewableEnergy.items = [];

        this.existing.equipment.totalItems = data.esg_equipment.length;
        this.existing.equipment.items = data.esg_equipment.map(
          ({ ...rest }) => ({
            ...rest,
            type_equipment: typeEquipmentEnum.BERGERAK,
            equipment: rest.id_equipment
              ? {
                  id: rest.id_equipment,
                  name: rest.name,
                  type: rest.type,
                  active: true,
                }
              : null,
            uuid: crypto.randomUUID(),
            duplicate: false,
            deleted: false,
            changed: false,
            action: null,
          })
        );

        this.existing.fuel.totalItems = data.esg_fuel.length;
        this.existing.fuel.items = data.esg_fuel.map(({ ...rest }) => ({
          ...rest,
          fuel: rest.id_fuel
            ? {
                id: rest.id_fuel,
                name: rest.name,
                active: true,
              }
            : null,
          uuid: crypto.randomUUID(),
          duplicate: false,
          deleted: false,
          changed: false,
          action: null,
        }));
        this.existing.electric.totalItems = data.esg_electric.length;
        this.existing.electric.items = data.esg_electric.map(({ ...rest }) => ({
          ...rest,
          file: null,
          url_file: rest.is_file ? rest.file : null,
          electric: rest.id_electric
            ? {
                id: rest.id_electric,
                name: rest.name,
                active: true,
                konversi_pln: rest.konversi_pln,
                is_file: rest.is_file,
                is_unit: rest.is_unit,
                description_unit: rest.description_unit,
                description_file: rest.description_file,
              }
            : null,
          uuid: crypto.randomUUID(),
          duplicate: false,
          deleted: false,
          changed: false,
          action: null,
        }));
        this.existing.renewableEnergy.totalItems =
          data.esg_renewable_energy.length;
        this.existing.renewableEnergy.items = data.esg_renewable_energy.map(
          ({ ...rest }) => ({
            ...rest,
            type: rest.id_renewable_energy
              ? {
                  id: rest.id_renewable_energy,
                  name: rest.name,
                  active: true,
                  konversi_pln: rest.konversi_pln,
                }
              : null,
            uuid: crypto.randomUUID(),
            duplicate: false,
            deleted: false,
            changed: false,
            action: null,
          })
        );

        this.existing.lastSaved = data.updated_at;
        this.existing.approved_by = data.approved_by;
        if (
          !this.status ||
          this.status === StatusEnum.DRAFT ||
          this.status === StatusEnum.REVISION ||
          (this.status === StatusEnum.COMPLETED && this.isAdmin)
        ) {
          if (this.workArea === WorkAreaEnum.HAULING) {
            const randomUUID = [];
            for (
              let index = 0;
              index < this.existing.equipment.items.length;
              index++
            ) {
              if (this.existing.equipment.items[index].equipment?.id) {
                this.listEquipment[index] = {
                  uuid: this.existing.equipment.items[index].uuid,
                  value: [
                    {
                      title: this.existing.equipment.items[index].name,
                      value: {
                        id: this.existing.equipment.items[index].equipment.id,
                        name: this.existing.equipment.items[index].name,
                        type: this.existing.equipment.items[index].type,
                        active: true,
                      },
                    },
                  ],
                };
              }
              randomUUID.push({
                uuid: this.existing.equipment.items[index].uuid,
                used: this.existing.equipment.items[index].equipment?.id
                  ? true
                  : false,
              });
            }
            if (randomUUID.length) {
              this.getEquipment(
                null,
                typeEquipmentEnum.BERGERAK,
                randomUUID,
                -1
              );
            }
          }

          const fuelUUID = [];
          for (
            let index = 0;
            index < this.existing.fuel.items.length;
            index++
          ) {
            if (this.existing.fuel.items[index].fuel?.id) {
              this.listFuel[index] = {
                uuid: this.existing.fuel.items[index].uuid,
                value: [
                  {
                    title: this.existing.fuel.items[index].name,
                    value: {
                      id: this.existing.fuel.items[index].fuel.id,
                      name: this.existing.fuel.items[index].name,
                      active: true,
                    },
                  },
                ],
              };
            }
            fuelUUID.push({
              uuid: this.existing.fuel.items[index].uuid,
              used: this.existing.fuel.items[index].fuel?.id ? true : false,
            });
          }
          if (fuelUUID.length) {
            this.getFuel(null, fuelUUID, -1);
          }

          const electricUUID = [];
          for (
            let index = 0;
            index < this.existing.electric.items.length;
            index++
          ) {
            if (this.existing.electric.items[index].electric?.id) {
              this.listElektric[index] = {
                uuid: this.existing.electric.items[index].uuid,
                value: [
                  {
                    title: this.existing.electric.items[index].name,
                    value: {
                      id: this.existing.electric.items[index].electric.id,
                      name: this.existing.electric.items[index].name,
                      active: true,
                      konversi_pln:
                        this.existing.electric.items[index].konversi_pln,
                      is_file: this.existing.electric.items[index].is_file,
                      is_unit: this.existing.electric.items[index].is_unit,
                      description_unit:
                        this.existing.electric.items[index].description_unit,
                      description_file:
                        this.existing.electric.items[index].description_file,
                    },
                  },
                ],
              };
            }
            electricUUID.push({
              uuid: this.existing.electric.items[index].uuid,
              used: this.existing.electric.items[index].electric?.id
                ? true
                : false,
            });
          }
          if (electricUUID.length) {
            this.getElectric(null, electricUUID, -1);
          }

          const renewableUUID = [];
          for (
            let index = 0;
            index < this.existing.renewableEnergy.items.length;
            index++
          ) {
            if (this.existing.renewableEnergy.items[index].type?.id) {
              this.listRenewableEnergy[index] = {
                uuid: this.existing.renewableEnergy.items[index].uuid,
                value: [
                  {
                    title: this.existing.renewableEnergy.items[index].name,
                    value: {
                      id: this.existing.renewableEnergy.items[index].type.id,
                      name: this.existing.renewableEnergy.items[index].name,
                      active: true,
                      konversi_pln:
                        this.existing.renewableEnergy.items[index].konversi_pln,
                    },
                  },
                ],
              };
            }
            renewableUUID.push({
              uuid: this.existing.renewableEnergy.items[index].uuid,
              used: this.existing.renewableEnergy.items[index].type?.id
                ? true
                : false,
            });
          }
          if (renewableUUID.length) {
            this.getRenewableEnergy(null, renewableUUID, -1);
          }
        }

        const page = 1;
        const perPage = 10;
        const startIndex = (page - 1) * perPage;

        this.dataTableEquipment.items = this.existing.equipment.items
          .map((item, index) => ({ ...item, existing_index: index }))
          .slice(startIndex, startIndex + perPage);
        this.dataTableFuel.items = this.existing.fuel.items
          .map((item, index) => ({ ...item, existing_index: index }))
          .slice(startIndex, startIndex + perPage);
        this.dataTableElectric.items = this.existing.electric.items
          .map((item, index) => ({ ...item, existing_index: index }))
          .slice(startIndex, startIndex + perPage);
        this.dataTableRenewableEnergy.items =
          this.existing.renewableEnergy.items
            .map((item, index) => ({ ...item, existing_index: index }))
            .slice(startIndex, startIndex + perPage);

        this.dataTableEquipment.start_index = startIndex;
        this.dataTableFuel.start_index = startIndex;
        this.dataTableElectric.start_index = startIndex;
        this.dataTableRenewableEnergy.start_index = startIndex;

        Object.assign(this.bodyNotification, {
          id_contractor: data.id_contractor,
          area: data.area,
        });
      } catch (err) {
        this.setLoading(false);
        util.showError(err);
        console.log({ err });
      } finally {
        this.fetchDataComment();
        setTimeout(() => {
          this.setLoading(false);
        }, 500);
      }
    },
    async getPjo() {
      const response = await axios.get(`${base_url_cms}cms/kontraktor/detail`, {
        params: {
          id_kontraktor: this.userData.kontraktorID,
        },
        headers: {
          role: "kontraktor",
          Authorization: "Bearer " + this.userData.token,
          accept: "*/*",
        },
      });
      return response.data.detailKontraktor.namaPjo;
    },
    async saveData(sub_id_contractor, id) {
      this.closeComment();

      if (
        this.status !== StatusEnum.WAITING_APPROVAL &&
        this.status !== StatusEnum.COMPLETED &&
        this.status !== StatusEnum.REVISION
      ) {
        await this.submitData(false, false);
      }

      if (this.idEsg && id) {
        this.$router.push(
          `/esg-report/${this.year}/${this.month.id}/${this.workArea}/${this.idEsg}/${this.kontraktorName}/${sub_id_contractor}/${id}`
        );
      } else if (this.idEsg) {
        this.$router.push(
          `/esg-report/${this.year}/${this.month.id}/${this.workArea}/${this.idEsg}/${this.kontraktorName}/${sub_id_contractor}`
        );
      }
    },
    async submitData(submitted, back) {
      this.loading(true);
      try {
        let esg_fuel = this.existing.fuel.items
          .filter((dta) => dta.changed)
          .filter((item) => item.id || (!item.id && !item.deleted))
          .map((data) => ({
            id: data.id,
            type_equipment: data.type_equipment,
            id_fuel: data.fuel?.id,
            volume: data.volume,
            distance: data.distance,
            name: data.fuel?.name,
            action: !data.id
              ? ActionEnum.CREATE
              : data.deleted
              ? ActionEnum.DELETE
              : ActionEnum.UPDATE,
          }));

        let esg_electric = await Promise.all(
          this.existing.electric.items
            .filter((dta) => dta.changed)
            .filter((item) => item.id || (!item.id && !item.deleted))
            .map(async (data) => {
              let fileName = null;
              if (data.electric?.is_file) {
                if (data.file) {
                  const res = await upload(
                    data.file,
                    TypeFileEnum.ESG_ELECTRIFICATION
                  );
                  fileName = res?.data?.filename || null;
                } else {
                  fileName = data.url_file;
                }
              }

              return {
                id: data.id,
                id_electric: data.electric?.id,
                unit: data.unit,
                file: fileName,
                total: data.total,
                is_file: data.electric?.is_file,
                is_unit: data.electric?.is_unit,
                name: data.electric?.name,
                konversi_pln: data.electric?.konversi_pln,
                description_unit: data.electric?.description_unit,
                description_file: data.electric?.description_file,
                action: !data.id
                  ? ActionEnum.CREATE
                  : data.deleted
                  ? ActionEnum.DELETE
                  : ActionEnum.UPDATE,
              };
            })
        );

        let esg_renewable_energy = this.existing.renewableEnergy.items
          .filter((dta) => dta.changed)
          .filter((item) => item.id || (!item.id && !item.deleted))
          .map((data) => ({
            id: data.id,
            id_renewable_energy: data.type?.id,
            consume: data.consume,
            name: data.type?.name,
            konversi_pln: data.type?.konversi_pln,
            action: !data.id
              ? ActionEnum.CREATE
              : data.deleted
              ? ActionEnum.DELETE
              : ActionEnum.UPDATE,
          }));

        let esg_equipment = this.existing.equipment.items
          .filter((dta) => dta.changed)
          .filter((item) => item.id || (!item.id && !item.deleted))
          .map((data) => ({
            id: data.id,
            id_equipment: data.equipment?.id,
            unit: parseInt(data.unit),
            name: data.equipment?.name,
            type: data.equipment?.type,
            action: !data.id
              ? ActionEnum.CREATE
              : data.deleted
              ? ActionEnum.DELETE
              : ActionEnum.UPDATE,
          }));

        let bodyJson = {
          id_contractor: parseInt(this.kontraktorID),
          source: "cms",
          initials: this.initials,
          area: this.workArea,
          contractor_name: this.kontraktorName,
          id_month: parseInt(this.month.id),
          year: this.year,
          production_ob: this.production.ob_production ?? "0",
          production_coal: this.production.coal_production ?? "0",
          submitted: submitted,
          filled_by: this.filled_by,
          is_admin: this.isAdmin,
          esg_fuel,
          esg_electric,
          esg_renewable_energy,
          esg_equipment,
          is_parent: this.$route.params.id_contractor ? false : true,
        };

        if (this.file_validity && !this.isAdmin) {
          bodyJson.file_validity = this.file_validity;
        }

        if (this.$route.params.id_contractor) {
          bodyJson.id_parent = parseInt(this.$route.params.id);
        }

        if (!this.idEsg) {
          bodyJson.pjo = await this.getPjo();
        }

        let response;
        if (this.idEsg) {
          response = await axios.put(`${base_url}/esg/${this.idEsg}`, bodyJson);
        } else {
          response = await axios.post(`${base_url}/esg`, bodyJson);
          this.idEsg = response.data.data.id;
        }

        const paths = [
          this.existing.equipment,
          this.existing.fuel,
          this.existing.renewableEnergy,
          this.existing.electric,
          this.dataTableEquipment,
          this.dataTableFuel,
          this.dataTableElectric,
          this.dataTableRenewableEnergy,
        ];

        paths.forEach((obj) => {
          obj.items = [];
          obj.page = 1;
          obj.perPage = 10;
          obj.totalItems = 0;
          obj.loading = false;
        });

        if (submitted) {
          await this.sendNotification(
            bodyJson,
            this.isAdmin
              ? JenisNotifEsgEnum.ADMIN_SUBMIT
              : JenisNotifEsgEnum.INPUTERS_SUBMIT
          );
        }
        this.loading(false);

        if (back) {
          util.showInfo(response.data.message);
          if (this.$route.params.id_contractor) {
            this.$router.push(
              `/esg-report/${this.year}/${this.month.id}/${this.workArea}/${this.$route.params.id}`
            );
          } else if (submitted) {
            this.$router.push({ path: "/esg-report", query: this.$route.query });
          } else {
            this.getEsgDetil(this.idEsg);
            this.$router.push(
              `/esg-report/${this.year}/${this.month.id}/${this.workArea}/${this.idEsg}`
            );
          }
        }

        if (back && submitted && !this.isAdmin) {
          this.closeModal();
        }
      } catch (err) {
        this.loading(false);
        util.showError(err);
      }
    },
    async openComment() {
      this.commentVisible = true;
      await this.fetchDataComment();

      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
    closeComment() {
      this.commentVisible = false;
    },
    async fetchDataComment() {
      try {
        const response = await axios.get(`${base_url}/esg-comment`, {
          params: {
            id_esg: this.idEsg,
          },
        });
        this.comments = response.data.data.map((item) => ({
          ...item,
          edit: false,
        }));
      } catch (err) {
        util.showError(err);
      }
    },
    async addComment() {
      const formData = await this.$refs.formComment.validate();
      if (formData.valid) {
        let bodyJson = {
          id_esg: this.idEsg ? parseInt(this.idEsg) : null,
          status: StatusEsgCommentEnum.DRAFT,
          message: this.formComment?.trim(),
          created_by: this.userData.email,
        };

        try {
          await axios.post(`${base_url}/esg-comment`, bodyJson);
        } catch (err) {
          util.showError(err);
        } finally {
          this.formComment = null;
          this.fetchDataComment();
        }
      }
    },
    editComment(id) {
      this.comments = this.comments.map((data) => {
        if (data.id === id) {
          return {
            ...data,
            edit: true,
          };
        } else {
          return {
            ...data,
            edit: false,
          };
        }
      });
      this.$nextTick(() => {
        const element = document.getElementById("edit_comment_" + id);
        if (element) {
          element.focus();
        }
      });
    },
    cancelComment() {
      this.comments = this.comments.map((item) => ({
        ...item,
        edit: false,
      }));
    },
    async updateComment(id, message) {
      try {
        let bodyJson = {
          id_esg: this.idEsg ? parseInt(this.idEsg) : null,
          status: StatusEsgCommentEnum.DRAFT,
          message: message,
          updated_by: this.userData.email,
        };
        await axios.put(`${base_url}/esg-comment/${id}`, bodyJson);
      } catch (err) {
        util.showError(err);
      } finally {
        this.fetchDataComment();
      }
    },
    async deleteComment(id) {
      try {
        let bodyJson = {
          id: id,
        };

        await axios.delete(`${base_url}/esg-comment`, {
          data: bodyJson,
        });
      } catch (err) {
        util.showError(err);
      } finally {
        this.fetchDataComment();
      }
    },
    async solvedComment(id) {
      try {
        let bodyJson = {
          id_esg: this.idEsg ? parseInt(this.idEsg) : null,
          updated_by: this.userData.email,
        };
        await axios.put(`${base_url}/esg-comment/solved/${id}`, bodyJson);
      } catch (err) {
        util.showError(err);
      } finally {
        this.fetchDataComment();
      }
    },
    async actionValidate(action) {
      try {
        this.loading(true);
        let bodyJson = {
          id: parseInt(this.idEsg),
          status: action,
        };
        const dataBody = this.bodyNotification;
        if (action === StatusEnum.COMPLETED) {
          Object.assign(bodyJson, {
            approved_by: this.userData.email,
          });
          await this.sendNotification(dataBody, JenisNotifEsgEnum.PJO_APPROVE);
        }
        if (action === StatusEnum.REVISION) {
          await this.sendNotification(dataBody, JenisNotifEsgEnum.PJO_REVISION);
        }
        const response = await axios.post(`${base_url}/esg/validate`, bodyJson);

        this.loading(false);
        util.showInfo(response.data.message);
        this.$router.push({ path: "/esg-report", query: this.$route.query });
      } catch (err) {
        this.loading(false);
        util.showError(err);
      }
    },
    async sendNotification(data, jenis) {
      try {
        const bodyJson = {
          kontraktorId: parseInt(data.id_contractor),
          infoReport: this.month.name + " - " + this.year,
          inputers: this.userData.email,
          jenisNotification:
            jenis === JenisNotifEsgEnum.PJO_REVISION
              ? JenisNotifEsgEnum.PJO_REVISION
              : jenis === JenisNotifEsgEnum.ADMIN_SUBMIT
              ? JenisNotifEsgEnum.ADMIN_SUBMIT
              : jenis == JenisNotifEsgEnum.PJO_APPROVE
              ? JenisNotifEsgEnum.PJO_APPROVE
              : JenisNotifEsgEnum.INPUTERS_SUBMIT,
          workArea: data.area,
          year: this.year,
          idMonth: parseInt(this.month.id),
          id: parseInt(this.idEsg),
        };

        await axios.post(`${url_send_notification}`, bodyJson);
      } catch (error) {
        console.error("Error sending notification:", error);
      }
    },
    getSummary(idTab) {
      try {
        this.tabs = this.tabs.map((item) => ({
          ...item,
          active: item.id === idTab ? true : false,
        }));

        const summaryActive = this.tabs.find((item) => item.active);

        this.calculateSummary(summaryActive.id);
      } catch (err) {
        util.showError(err);
      }
    },
    async setTabSummary(idParent = null) {
      try {
        if (!idParent) {
          this.tabs = [
            {
              id: null,
              name: this.kontraktorName,
              id_contractor: null,
              status: null,
              updated_at: null,
              active: true,
              isMain: true,
              valid: 0,
            },
          ];
        } else {
          let params = {
            id_parent: idParent,
          };
          const res = await axios.get(
            `${base_url}/esg/find-sub-contractor-by-parent`,
            {
              params: params,
            }
          );

          this.tabs = [
            {
              id: parseInt(idParent),
              name:
                this.$route.params.main_contractor_name ?? this.kontraktorName,
              id_contractor: null,
              status: null,
              updated_at: null,
              active: true,
              isMain: true,
              valid: 0,
            },
          ];

          this.tabs.push(
            ...res.data.data?.map((item) => ({
              id: item.id,
              name: item.contractor_name,
              id_contractor: item.id_contractor,
              status: item.status,
              updated_at: item.updated_at,
              active: false,
              isMain: false,
              valid: item.valid,
            }))
          );

          if (this.$route.params.id_contractor) {
            const kontraktorId = parseInt(this.$route.params.id_contractor);

            const existing = this.tabs.find(
              (item) => item.id_contractor === kontraktorId
            );

            if (!existing) {
              this.tabs.push({
                id: null,
                name: null,
                id_contractor: kontraktorId,
                status: null,
                updated_at: null,
                active: true,
                isMain: false,
              });
            }
          }
        }
      } catch (err) {
        util.showError(err);
      }
    },
    async detilContractor(id_contractor) {
      try {
        let params = {
          id_kontraktor: id_contractor,
        };

        const res = await axios.get(`${base_url_cms}cms/kontraktor/detail`, {
          params: params,
          headers: {
            role: "kontraktor",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        const result = res.data;

        this.initials = result.detailKontraktor.inisial;
        this.kontraktorName = result.detailKontraktor.namaKontraktor;

        this.tabs = this.tabs.map((item) => {
          return {
            ...item,
            name:
              item.isMain && this.$route.params.id_contractor
                ? this.$route.params.main_contractor_name
                : (item.isMain && !this.$route.params.id_contractor) ||
                  item.id_contractor ===
                    parseInt(this.$route.params.id_contractor)
                ? this.kontraktorName
                : item.name,
            active:
              item.isMain && !this.$route.params.id_contractor
                ? true
                : item.isMain && this.$route.params.id_contractor
                ? false
                : !item.isMain &&
                  parseInt(this.$route.params.id_contractor) ===
                    item.id_contractor
                ? true
                : false,
          };
        });

        if (!this.$route.params.id_contractor && result.subkontraktor?.length) {
          this.subContractor = result.subkontraktor?.map((item) => ({
            id: null,
            id_contractor: item.idKontraktor,
            contractor_name: item.namaKontraktor,
            updated_at: null,
            valid: 0,
          }));

          this.subContractor = this.subContractor?.map((sub) => {
            const matching = this.tabs.find(
              (ref) => ref.id_contractor === sub.id_contractor && !ref.isMain
            );

            if (matching) {
              return {
                ...sub,
                id: matching.id,
                status: matching.status,
                updated_at: matching.updated_at,
                valid: matching.valid,
              };
            }
            return sub;
          });

          this.setValid();
        }
      } catch (err) {
        util.showError(err);
      }
    },
    async openDialogGenerateFileValidity() {
      try {
        const sio = await getSIOByIDContractor(this.kontraktorID);

        const idSio = sio.data.id;

        const contractor = await axios.get(
          `${base_url_cms}cms/kontraktor/detail`,
          {
            params: {
              id_kontraktor: this.kontraktorID,
            },
            headers: {
              role: "kontraktor",
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          }
        );

        const completeness = await axios.get(
          `${base_url_cms}cms/sio/kelengkapan`,
          {
            params: {
              sio: idSio,
            },
            headers: {
              role: "kontraktor",
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          }
        );

        const dataContractor = contractor.data.detailKontraktor;

        this.pjo.name = dataContractor.namaPjo;

        if (sio.data.downloadUrlPjo != null) {
          this.pjo.name = completeness.data.namaPjo;
          this.pjo.ttd =
            completeness.data.ttdPjo !== "" && completeness.data.ttdPjo
              ? completeness.data.ttdPjo
              : null;
        }

        this.dialogGenerateFileValidity = true;
      } catch (err) {
        util.showError(err);
      }
    },
  },
};
</script>

<style scoped>
:deep(thead:not(.summary)) {
  background-color: #f0f1f4;
  font-weight: 500;
  font-size: 13px;
  color: #232323;
}

.custom-textarea :deep(textarea) {
  font-size: 12px !important;
  padding: 5px !important;
}
</style>
